import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showFilter: '=',
        sites: '=',
        classifiers: '=',
        filter: '=',
        errors: '=',
        showIndividualAnswers: '='
    },
    template: `
        <div class="table-filters">
            <h2 ng-if="vm.showFilter===true">{{ 'filter.Filter report' | translate }}</h2>
            <form class="form form-filter print-visible" ng-if="vm.showFilter===true" ng-submit="vm.applyFilter()">
                <div class="fields">
                    <div class="row row-md row-flex02">
                        <label class="label">{{ 'filter.Department' | translate }}</label>
                        <form-row error="vm.errors.departmentIds" ng-if="vm.errors.departmentIds">
                            <form-row-error></form-row-error>
                        </form-row>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                options="vm.FilterService.departmentSelect.options"
                                selected-model="vm.FilterService.departmentSelect.models"
                                extra-settings="vm.FilterService.departmentSelect.settings"
                                events="vm.FilterService.departmentSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row row-md row-flex02">
                        <label class="label">{{ 'filter.Site' | translate }}</label>
                        <form-row error="vm.errors.siteIds" ng-if="vm.errors.siteIds">
                            <form-row-error></form-row-error>
                        </form-row>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                options="vm.multiFilter.sites.options"
                                selected-model="vm.multiFilter.sites.model"
                                extra-settings="vm.multiFilter.sites.settings"
                                ng-click="vm.updateEmployees()"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row row-flex02">
                        <label class="label">{{ 'filter.Period' | translate }}<small>({{ 'filter.From' | translate }})</small></label>
                        <form-row error="vm.errors.from" ng-if="vm.errors.from">
                            <form-row-error></form-row-error>
                        </form-row>
                        <div class="">
                            <datepicker-api ng-model="vm.filter.from"></datepicker-api>
                        </div>
                    </div>
                    <div class="row row-flex02">
                        <label class="label">{{ 'filter.Period' | translate }}<small>({{ 'filter.To' | translate }})</small></label>
                        <form-row error="vm.errors.to" ng-if="vm.errors.to">
                            <form-row-error></form-row-error>
                        </form-row>
                        <div class="">
                            <datepicker-api ng-model="vm.filter.to"></datepicker-api>
                        </div>
                    </div>
                    <div class="row row-md row-flex02">
                        <label class="label">{{ 'filter.Direct manager' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedEmployee"
                                ng-model="vm.filter.directManagerId"
                                value-attribute="'id'"
                                query="vm.queryUsers(input)"
                            />
                        </div>
                    </div>
                    <div class="row row-md">
                        <span class="label">{{ 'filter.Display individual answers' | translate }}</span>
                        <div class="items">
                            <label class="switch01 mt1em">
                                <input type="checkbox" name="switch" ng-model="vm.showIndividualAnswers">
                                <span>On</span>
                            </label>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input type="button" ng-click="vm.resetFilter()" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor ($translate, $scope, $timeout, lodash, CLASSIFIER_ENUM, SiteService, FilterService, ROLE_CODE_ENUM,
        UserResource, moment) {
        this.$translate = $translate;
        this.moment = moment;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.lodash = lodash;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.SiteService = SiteService;
        this.FilterService = FilterService;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.UserResource = UserResource;
    }

    resetFilter () {
        this.filter = {};
        this.filter.to = this.moment().format('YYYY-MM-DD');
        this.showIndividualAnswers = false;
        this.initMultiFilter();
        setTimeout(() => {
            this.applyFilter();
        }, '300'
        );
    }

    $onInit () {
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);

        this.initMultiFilter();

        this.filterOverview = {
            labels: {
                'siteIds[]': this.$translate.instant('filter.Site'),
                'departmentIds[]': this.$translate.instant('filter.Employee department')
            },
            values: {}
        };
    }

    queryUsers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
            'siteIds[]': this.sites.map(site => site.id),
            name: input,
            pageSize: 0
        };
        return this.UserResource.query(params).$promise;
    }

    initMultiFilter () {
        this.FilterService.init(this.classifiers);

        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        const siteOptionsSelected = siteOptions.map(site => site);

        this.multiFilter = {
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };

        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    applyFilter () {
        const siteIds = !this.multiFilter.sites.model.length ? [-1] : this.multiFilter.sites.model.map(site => site.value);

        this.filter = this.lodash.assign(this.filter, { siteIds });
        this.filter.departmentIds = this.FilterService.departmentSelect.models
        .filter((department) => department.id !== null)
        .map((department) => department.id);

        this.$scope.$parent.vm.loadReport();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/survey/public/report/filter/report/index.js